import { render, staticRenderFns } from "./GnpLogo.vue?vue&type=template&id=a5aa53e4&scoped=true&"
import script from "./GnpLogo.vue?vue&type=script&lang=js&"
export * from "./GnpLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aa53e4",
  null
  
)

export default component.exports